<template>
  <modal class="modal-study" @close="closeModal()" @closeAndSaveCookie="saveCookieAndCloseModal()" :displayCross="false">
    <div class="card-container">
      <div class="title">
        <img src="@/assets/img/icons.svg#icon-study" width="45" height="50">
        <big-title :text="'Info étude clinique'" class="u-color--orange"  :hasBlock="true"/>
      </div>
      <div class="separator-study"></div>
      <simple-title :text="study.title" />
      <!--<sub-title :text="'Sous titre'"/>-->
      <tag :tag="study.type" class="u-color--orange u-bg--orange-soft"/>
      <paragraph :text="study.chapo" />
      <block-infos :infos="[{label: 'Porteur de projet', data: study.contactName}, {label: 'Contact', data: study.contactEmail},{label: 'Date limite d\'inscription', data: study.maxSubscriptionDate, date: true}]"/>
      <!--<link-arrow-left :theme="'orange'" :text="'Plus d’informations et coordonnées'" class="u-color--orange"  :href="'/etude/' + study.slug" />-->
    </div>
    <div class="col-12 d-flex justify-content-between button">
      <round-button-icon :text="'En savoir +'" class="u-bg--orange" :href="study.subscriptionUrl" :targetBlank="true"/>
    </div>
  </modal>
</template>

<script>
  import Modal from "../Granular/Modal";
  import BigTitle from '../../Core/BigTitle'
  import SimpleTitle from '../../Core/SimpleTitle'
  import Paragraph from './../../Core/Paragraph'
  import LinkArrowLeft from "../../Core/Link/LinkArrowLeft";
  import Tag from "../../Card/Granular/Tag";
  import BlockInfos from "../../Card/Granular/BlockInfos";
  import RoundButtonIcon from "../../Core/RoundButtonIcon";
  import SimpleLink from "../../Core/Link/SimpleLink";
  import SubTitle from "../../Core/SubTitle";

  export default {
    name: "Modal-study",
    props: ['study'],
    data: () => {
      return {
        dontShowAgain: false
      }
    },
    components: {
      SubTitle,
      SimpleLink,
      RoundButtonIcon,
      BlockInfos,
      Tag,
      LinkArrowLeft,
      BigTitle,
      SimpleTitle,
      Paragraph,
      Modal
    },
    methods: {
      saveCookieAndCloseModal() {
        this.dontShowAgain = true
        this.closeModal()
      },
      closeModal() {
        if (this.dontShowAgain) {
          this.$cookies.set('showModal_' + this.study._id, 0)

          this.dontShowAgain = false
        }

        this.$emit('close');
      }
    },
  }
</script>

<style lang="scss">
  .modal-study {
    .modal {
      min-height: rem(500px);

      .title {
        display: flex;
        align-items: center;
        margin: 0;

        .iconTitle {
          font-size: rem(22px);
          line-height: rem(24px);
        }

        svg {
          margin-right: rem(15px);
        }
      }

      .separator {
        display: none;
      }

      .separator-study {
        position: relative;
        margin-bottom: rem(25px);
        padding-top: rem(25px);

        &::after {
          content: '';
          width: 100%;
          position: absolute;
          height: 1px;
          background-color: color(grey-light);
        }
      }

      .subTitle {
        padding: rem(5px) 0;

      }

      .block-infos {
        border-left: 1px solid color(orange);
      }

      .button {
        align-items: center;
        flex-wrap: wrap;

        .cta-round {
          margin: 0;

          &:hover, &:focus {
            background-color: color(orange-hover);
          }
        }
      }

      .col-12 {
        padding: 0;
      }
    }
  }

</style>
